// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { _ } from "~/i18n";

/**
 * @class Horní nadpisová část vizitky
 * @private
 */
 export default class Inaccurate extends Content {
	_build() {
		this._dom.container.classList.add("content-inaccurate");
		if(this._data) {
			this._dom.container.innerHTML = "<p>" + _("detail.content.inaccurate") + ".</p>";
		}
	}
}
